var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 100,
    viewBox: "0 0 400 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 0H0V100H400V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.57 12H3.33C1.49 12 0 13.44 0 15.21V65.82C0 67.59 1.49 69.03 3.33 69.03H28.57C44.35 69.03 57.14 56.27 57.14 40.52C57.14 24.77 44.35 12 28.57 12Z",
    fill: "#EE771D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.89 38.01C366.17 38.01 358.44 37.92 350.72 38.06C348.31 38.1 347.6 37.44 347.78 35.04C348.74 22.55 360.39 12.14 373.72 12.01C387.17 11.87 398.69 21.9 399.95 34.55C400.24 37.48 399.4 38.13 396.61 38.07C389.04 37.9 381.47 38.01 373.89 38.01Z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.76 43.04C381.36 43.04 388.96 43.2 396.55 42.96C399.8 42.86 400.25 43.97 399.9 46.87C398.38 59.63 386.9 69.22 373.1 69.02C360.02 68.83 348.86 58.7 347.79 46.23C347.56 43.56 348.42 42.93 350.97 42.98C358.56 43.13 366.16 43.03 373.76 43.03V43.04Z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.98 69.04C104.759 69.04 117.55 56.2757 117.55 40.53C117.55 24.7844 104.759 12.02 88.98 12.02C73.2012 12.02 60.41 24.7844 60.41 40.53C60.41 56.2757 73.2012 69.04 88.98 69.04Z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.08 40.53V65.72C124.08 67.55 125.52 69.04 127.29 69.04H178.01C179.78 69.04 181.22 67.55 181.22 65.72V40.53C181.22 24.78 168.43 12.02 152.65 12.02C136.87 12.02 124.08 24.78 124.08 40.53Z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.33 69.05H241.57C243.41 69.05 244.9 67.61 244.9 65.84V15.23C244.9 13.46 243.41 12.02 241.57 12.02H216.33C200.55 12.02 187.76 24.78 187.76 40.53C187.76 56.28 200.55 69.04 216.33 69.04V69.05Z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 12H254.76C252.92 12 251.43 13.44 251.43 15.21V65.82C251.43 67.59 252.92 69.03 254.76 69.03H280C295.78 69.03 308.57 56.27 308.57 40.52C308.57 24.77 295.78 12.01 280 12.01V12Z",
    fill: "#EE771D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.23 12H313.84C312.735 12 311.84 12.8954 311.84 14V67.02C311.84 68.1246 312.735 69.02 313.84 69.02H339.23C340.335 69.02 341.23 68.1246 341.23 67.02V14C341.23 12.8954 340.335 12 339.23 12Z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.66 74.01C226.26 74.01 233.86 74.17 241.45 73.93C244.7 73.83 245.15 74.94 244.8 77.84C243.28 90.6 231.8 100.19 218 99.99C204.92 99.8 193.76 89.67 192.69 77.2C192.46 74.53 193.32 73.9 195.87 73.95C203.46 74.1 211.06 74 218.66 74V74.01Z",
    fill: "#040000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.abe65018fef5e3b4f5fd0896ec38b457.svg";
export { ForwardRef as ReactComponent };